const formularioAgricola = {
  id: 'group-agricola',
  title: 'Módulo Registrador',
  type: 'group',
  children: [
    {
      id: 'menu-registrador',
      title: 'Registrador',
      icon: 'ph ph-note-pencil',
      type: 'collapse',
      children: [
        {
          id: 'problema-agricola',
          title: 'Nuevo Formulario',
          type: 'item',
          url: '/agricola/problema'
        },
        {
          id: 'mis-registros',
          title: 'Historial / Mis Cargas',
          type: 'item',
          url: '/agricola/mis-registros'
        },
        {
          id: 'mi-perfil',
          title: 'Editar Mi Usuario',
          type: 'item',
          url: '/agricola/mi-perfil'
        }
      ]
    }
  ]
};

export default formularioAgricola;